import React from "react"

const ProviderManageContext = React.createContext({})

const { Provider, Consumer } = ProviderManageContext

export { Provider, Consumer, ProviderManageContext }
